import { All, StaticDataActionTypes } from './static-data.action';
import { AuthActionTypes } from '@store/root-store/auth/auth.actions';
import { DescribableModel } from '@coreModels/describable.model';
import { INIT, UPDATE } from '@ngrx/store';
import { ADMIN_ACTIVITY_ASSET_TYPES } from '@enums/statis-data-reducer';

interface ActiveStatuses {
  companies: DescribableModel[];
  defect: DescribableModel[];
  dvir: DescribableModel[];
  elds: DescribableModel[];
  gpses: DescribableModel[];
  drivers: DescribableModel[];
}

export interface StaticDataState {
  activeStatuses: ActiveStatuses;
  cameraStatuses: any;
  cameraManufacturers: DescribableModel[];
  cameraBillingStatuses: DescribableModel[];
  adminUserTypes: DescribableModel[];
  alertTypes: DescribableModel[];
  vehicleAlerts: DescribableModel[];
  cameraAlerts: DescribableModel[];
  driverAlerts: DescribableModel[];
  trailerAlerts: DescribableModel[];
  geofenceAlerts: DescribableModel[];
  gpsAlerts: DescribableModel[];
  dijagnostika: DescribableModel[];
  groupAlertTypes: DescribableModel[];
  alertRecipientTypes: DescribableModel[];
  billingStatuses: DescribableModel[];
  cargoTypes: DescribableModel[];
  cycleRuleTypes: DescribableModel[];
  driverLogType: DescribableModel[];
  driverTypes: DescribableModel[];
  dvirReportTypes: DescribableModel[];
  dvirDefectTypes: DescribableModel[];
  vehicleDvirDefects: DescribableModel[];
  trailerDvirDefects: DescribableModel[];
  dailyLogEditHistoryActions: DescribableModel[];
  dutyStatuses: DescribableModel[];
  exportTypes: string[];
  fleetManagerRoles: DescribableModel[];
  fuelTypes: DescribableModel[];
  fuelPurchaseSourceTypes: DescribableModel[];
  geofenceShapes: DescribableModel[];
  geofenceTypes: DescribableModel[];
  gpsModelTypes: DescribableModel[];
  gpsManufacturers: DescribableModel[];
  licenseStates: DescribableModel[];
  maintenanceTypes: DescribableModel[];
  scheduleMaintenanceTypes: DescribableModel[];
  repairAndFaultMaintenanceTypes: DescribableModel[];
  dueInTypes: DescribableModel[];
  eldManufacturers: DescribableModel[];
  inspectionFormTypes: DescribableModel[];
  odometerUnits: DescribableModel[];
  properties: DescribableModel[];
  shortHaulExceptions: DescribableModel[];
  states: DescribableModel[];
  timeZones: DescribableModel[];
  europeTimeZones: DescribableModel[];
  africaTimeZones: DescribableModel[];
  trailerOwnerships: DescribableModel[];
  trailerSuspensions: DescribableModel[];
  tickTypes: DescribableModel[];
  trailerTypes: DescribableModel[];
  constructionAssetTypes: DescribableModel[];
  userRoles: DescribableModel[];
  violationErrors: DescribableModel[];
  documentTypes: DescribableModel[];
  simManufacturers: DescribableModel[];
  cameraViews: DescribableModel[];
  cameraAlarmSeverity: DescribableModel[];
  cameraAlarmTypes: (DescribableModel & { severity: string })[];
  cameraRequestedVideoStatus: DescribableModel[];
  availableTrucksEquipment: DescribableModel[];
  priorities: DescribableModel[];
  eldEventStatuses: DescribableModel[];
  maintenanceFrequencyTypes: DescribableModel[];
  geofenceAlertTypes: DescribableModel[] | null;
  specialStatuses: DescribableModel[];
  externalIntegrations: DescribableModel[];
  supportTypes: DescribableModel[];
  loadTypes: DescribableModel[];
  equipmentTypes: DescribableModel[];
  trailerOptionTypes: DescribableModel[];
  cameraAlarmStatuses: DescribableModel[];
  accessoriesStatuses: DescribableModel[];
  accessoriesTypes: DescribableModel[];
  accessoriesAlerts: DescribableModel[];
  activityAssetTypes: DescribableModel[];
  adminActivityAssetTypes: DescribableModel[];
  adminActivityFilterTypes: DescribableModel[];
  adminActivityStatuses: DescribableModel[];
  speedingSettingsThresholdValues: DescribableModel[];
  speedingSettingsSpeedingLevels: DescribableModel[];
  speedingSettingsDurationValues: DescribableModel[];
  vehicleTypes: DescribableModel[];
  assetTypes: DescribableModel[];
  companyRegions: DescribableModel[];
  pingFrequencyOptions: DescribableModel[];
}

const initialState: StaticDataState = {
  activeStatuses: {
    companies: [],
    defect: [],
    dvir: [],
    elds: [],
    gpses: [],
    drivers: [],
  },
  cameraStatuses: [],
  cameraManufacturers: [],
  cameraBillingStatuses: [],
  cargoTypes: [],
  adminUserTypes: [],
  alertTypes: [],
  vehicleAlerts: [],
  cameraAlerts: [],
  trailerAlerts: [],
  driverAlerts: [],
  geofenceAlerts: [],
  gpsAlerts: [],
  dijagnostika: [],
  groupAlertTypes: [],
  alertRecipientTypes: [],
  billingStatuses: [],
  cycleRuleTypes: [],
  fuelTypes: [],
  gpsModelTypes: [],
  gpsManufacturers: [],
  inspectionFormTypes: [],
  tickTypes: [],
  odometerUnits: [],
  shortHaulExceptions: [],
  states: [],
  licenseStates: [],
  driverLogType: [],
  timeZones: [],
  europeTimeZones: [],
  africaTimeZones: [],
  fleetManagerRoles: [],
  eldManufacturers: [],
  dutyStatuses: [],
  exportTypes: [],
  properties: [],
  driverTypes: [],
  violationErrors: [],
  dvirReportTypes: [],
  dvirDefectTypes: [],
  vehicleDvirDefects: [],
  trailerDvirDefects: [],
  dailyLogEditHistoryActions: [],
  trailerOwnerships: [],
  trailerSuspensions: [],
  trailerTypes: [],
  constructionAssetTypes: [],
  maintenanceTypes: [],
  scheduleMaintenanceTypes: [],
  repairAndFaultMaintenanceTypes: [],
  dueInTypes: [],
  userRoles: [],
  geofenceTypes: [],
  geofenceShapes: [],
  documentTypes: [],
  cameraViews: [],
  cameraAlarmSeverity: [],
  cameraAlarmTypes: [],
  cameraRequestedVideoStatus: [],
  fuelPurchaseSourceTypes: [],
  availableTrucksEquipment: [],
  simManufacturers: [],
  priorities: [],
  eldEventStatuses: [],
  maintenanceFrequencyTypes: [],
  geofenceAlertTypes: null,
  specialStatuses: [],
  externalIntegrations: [],
  supportTypes: [],
  loadTypes: [],
  equipmentTypes: [],
  trailerOptionTypes: [],
  cameraAlarmStatuses: [],
  accessoriesStatuses: [],
  accessoriesTypes: [],
  accessoriesAlerts: [],
  activityAssetTypes: [],
  adminActivityAssetTypes: [],
  adminActivityFilterTypes: [],
  adminActivityStatuses: [],
  speedingSettingsThresholdValues: [],
  speedingSettingsSpeedingLevels: [],
  speedingSettingsDurationValues: [],
  vehicleTypes: [],
  assetTypes: [],
  companyRegions: [],
  pingFrequencyOptions: [],
};

const loadInitialState = (): StaticDataState => {
  const data: Partial<StaticDataState> = {
    activeStatuses: {
      companies: [
        {
          id: 'pending',
          description: 'Pending',
        },
        {
          id: 'active',
          description: 'Active',
        },
        {
          id: 'deactivated',
          description: 'Deactivated',
        },
      ],
      elds: [
        {
          id: 'active',
          description: 'Active',
        },
        {
          id: 'deactivated',
          description: 'Deactivated',
        },
        {
          id: 'onHold',
          description: 'On Hold',
        },
        {
          id: 'replaced',
          description: 'Replaced',
        },
        {
          id: 'unassigned',
          description: 'Unassigned',
        },
        {
          id: 'freeTrial',
          description: 'Free Trial',
        },
      ],
      dvir: [
        {
          id: 'satisfactory',
          description: 'Vehicle Condition Satisfactory',
        },
        {
          id: 'notCorrected',
          description: 'Defects Not Corrected',
        },
        {
          id: 'corrected',
          description: 'Defects Corrected',
        },
        {
          id: 'needNoCorrection',
          description: 'Defects Need Not Be Corrected',
        },
      ],
      defect: [
        {
          id: 'corrected',
          description: 'Defect Corrected',
        },
        {
          id: 'notCorrected',
          description: 'Defect Not Corrected',
        },
        {
          id: 'notToBeCorrected',
          description: 'Defect Need Not Be Corrected',
        },
      ],
      gpses: [
        {
          id: 'active',
          description: 'Active',
        },
        {
          id: 'deactivated',
          description: 'Deactivated',
        },
        {
          id: 'onHold',
          description: 'On Hold',
        },
        {
          id: 'replaced',
          description: 'Replaced',
        },
        {
          id: 'unassigned',
          description: 'Unassigned',
        },
        {
          id: 'freeTrial',
          description: 'Free Trial',
        },
      ],
      drivers: [
        {
          id: true,
          description: 'Active',
        },
        {
          id: false,
          description: 'Deactivated',
        },
      ],
    },
    states: [
      {
        id: 'US_AL',
        description: 'Alabama',
      },
      {
        id: 'US_AK',
        description: 'Alaska',
      },
      {
        id: 'US_AZ',
        description: 'Arizona',
      },
      {
        id: 'US_AR',
        description: 'Arkansas',
      },
      {
        id: 'US_CA',
        description: 'California',
      },
      {
        id: 'US_CO',
        description: 'Colorado',
      },
      {
        id: 'US_CT',
        description: 'Connecticut',
      },
      {
        id: 'US_DE',
        description: 'Delaware',
      },
      {
        id: 'US_DC',
        description: 'District of Columbia',
      },
      {
        id: 'US_FL',
        description: 'Florida',
      },
      {
        id: 'US_GA',
        description: 'Georgia',
      },
      {
        id: 'US_HI',
        description: 'Hawaii',
      },
      {
        id: 'US_ID',
        description: 'Idaho',
      },
      {
        id: 'US_IL',
        description: 'Illinois',
      },
      {
        id: 'US_IN',
        description: 'Indiana',
      },
      {
        id: 'US_IA',
        description: 'Iowa',
      },
      {
        id: 'US_KS',
        description: 'Kansas',
      },
      {
        id: 'US_KY',
        description: 'Kentucky',
      },
      {
        id: 'US_LA',
        description: 'Louisiana',
      },
      {
        id: 'US_ME',
        description: 'Maine',
      },
      {
        id: 'US_MD',
        description: 'Maryland',
      },
      {
        id: 'US_MA',
        description: 'Massachusetts',
      },
      {
        id: 'US_MI',
        description: 'Michigan',
      },
      {
        id: 'US_MN',
        description: 'Minnesota',
      },
      {
        id: 'US_MS',
        description: 'Mississippi',
      },
      {
        id: 'US_MO',
        description: 'Missouri',
      },
      {
        id: 'US_MT',
        description: 'Montana',
      },
      {
        id: 'US_NE',
        description: 'Nebraska',
      },
      {
        id: 'US_NV',
        description: 'Nevada',
      },
      {
        id: 'US_NH',
        description: 'New Hampshire',
      },
      {
        id: 'US_NJ',
        description: 'New Jersey',
      },
      {
        id: 'US_NM',
        description: 'New Mexico',
      },
      {
        id: 'US_NY',
        description: 'New York',
      },
      {
        id: 'US_NC',
        description: 'North Carolina',
      },
      {
        id: 'US_ND',
        description: 'North Dakota',
      },
      {
        id: 'US_OH',
        description: 'Ohio',
      },
      {
        id: 'US_OK',
        description: 'Oklahoma',
      },
      {
        id: 'US_OR',
        description: 'Oregon',
      },
      {
        id: 'US_PA',
        description: 'Pennsylvania',
      },
      {
        id: 'US_RI',
        description: 'Rhode Island',
      },
      {
        id: 'US_SC',
        description: 'South Carolina',
      },
      {
        id: 'US_SD',
        description: 'South Dakota',
      },
      {
        id: 'US_TN',
        description: 'Tennessee',
      },
      {
        id: 'US_TX',
        description: 'Texas',
      },
      {
        id: 'US_UT',
        description: 'Utah',
      },
      {
        id: 'US_VT',
        description: 'Vermont',
      },
      {
        id: 'US_VA',
        description: 'Virginia',
      },
      {
        id: 'US_WA',
        description: 'Washington',
      },
      {
        id: 'US_WV',
        description: 'West Virginia',
      },
      {
        id: 'US_WI',
        description: 'Wisconsin',
      },
      {
        id: 'US_WY',
        description: 'Wyoming',
      },
    ],
    licenseStates: [
      {
        id: 'US_AL',
        description: 'Alabama',
      },
      {
        id: 'US_AK',
        description: 'Alaska',
      },
      {
        id: 'US_AZ',
        description: 'Arizona',
      },
      {
        id: 'US_AR',
        description: 'Arkansas',
      },
      {
        id: 'US_CA',
        description: 'California',
      },
      {
        id: 'US_CO',
        description: 'Colorado',
      },
      {
        id: 'US_CT',
        description: 'Connecticut',
      },
      {
        id: 'US_DE',
        description: 'Delaware',
      },
      {
        id: 'US_DC',
        description: 'District of Columbia',
      },
      {
        id: 'US_FL',
        description: 'Florida',
      },
      {
        id: 'US_GA',
        description: 'Georgia',
      },
      {
        id: 'US_HI',
        description: 'Hawaii',
      },
      {
        id: 'US_ID',
        description: 'Idaho',
      },
      {
        id: 'US_IL',
        description: 'Illinois',
      },
      {
        id: 'US_IN',
        description: 'Indiana',
      },
      {
        id: 'US_IA',
        description: 'Iowa',
      },
      {
        id: 'US_KS',
        description: 'Kansas',
      },
      {
        id: 'US_KY',
        description: 'Kentucky',
      },
      {
        id: 'US_LA',
        description: 'Louisiana',
      },
      {
        id: 'US_ME',
        description: 'Maine',
      },
      {
        id: 'US_MD',
        description: 'Maryland',
      },
      {
        id: 'US_MA',
        description: 'Massachusetts',
      },
      {
        id: 'US_MI',
        description: 'Michigan',
      },
      {
        id: 'US_MN',
        description: 'Minnesota',
      },
      {
        id: 'US_MS',
        description: 'Mississippi',
      },
      {
        id: 'US_MO',
        description: 'Missouri',
      },
      {
        id: 'US_MT',
        description: 'Montana',
      },
      {
        id: 'US_NE',
        description: 'Nebraska',
      },
      {
        id: 'US_NV',
        description: 'Nevada',
      },
      {
        id: 'US_NH',
        description: 'New Hampshire',
      },
      {
        id: 'US_NJ',
        description: 'New Jersey',
      },
      {
        id: 'US_NM',
        description: 'New Mexico',
      },
      {
        id: 'US_NY',
        description: 'New York',
      },
      {
        id: 'US_NC',
        description: 'North Carolina',
      },
      {
        id: 'US_ND',
        description: 'North Dakota',
      },
      {
        id: 'US_OH',
        description: 'Ohio',
      },
      {
        id: 'US_OK',
        description: 'Oklahoma',
      },
      {
        id: 'US_OR',
        description: 'Oregon',
      },
      {
        id: 'US_PA',
        description: 'Pennsylvania',
      },
      {
        id: 'US_RI',
        description: 'Rhode Island',
      },
      {
        id: 'US_SC',
        description: 'South Carolina',
      },
      {
        id: 'US_SD',
        description: 'South Dakota',
      },
      {
        id: 'US_TN',
        description: 'Tennessee',
      },
      {
        id: 'US_TX',
        description: 'Texas',
      },
      {
        id: 'US_UT',
        description: 'Utah',
      },
      {
        id: 'US_VT',
        description: 'Vermont',
      },
      {
        id: 'US_VA',
        description: 'Virginia',
      },
      {
        id: 'US_WA',
        description: 'Washington',
      },
      {
        id: 'US_WV',
        description: 'West Virginia',
      },
      {
        id: 'US_WI',
        description: 'Wisconsin',
      },
      {
        id: 'US_WY',
        description: 'Wyoming',
      },
      {
        id: 'AP_AS',
        description: 'American Samoa',
      },
      {
        id: 'AP_GU',
        description: 'Guam',
      },
      {
        id: 'AP_MP',
        description: 'Northern Marianas',
      },
      {
        id: 'AP_PR',
        description: 'Puerto Rico',
      },
      {
        id: 'AP_VI',
        description: 'Virgin Islands',
      },
      {
        id: 'CA_AB',
        description: 'Alberta',
      },
      {
        id: 'CA_BC',
        description: 'British Columbia',
      },
      {
        id: 'CA_MB',
        description: 'Manitoba',
      },
      {
        id: 'CA_NB',
        description: 'New Brunswick',
      },
      {
        id: 'CA_NL',
        description: 'Newfoundland and Labrador',
      },
      {
        id: 'CA_NT',
        description: 'Northwest Territories',
      },
      {
        id: 'CA_NS',
        description: 'Nova Scotia',
      },
      {
        id: 'CA_ON',
        description: 'Ontario',
      },
      {
        id: 'CA_PE',
        description: 'Prince Edward Island',
      },
      {
        id: 'CA_QC',
        description: 'Quebec',
      },
      {
        id: 'CA_SK',
        description: 'Saskatchewan',
      },
      {
        id: 'CA_YT',
        description: 'Yukon Territory',
      },
      {
        id: 'ME_AG',
        description: 'Aguascalientes',
      },
      {
        id: 'ME_BN',
        description: 'Baja California Norte',
      },
      {
        id: 'ME_BS',
        description: 'Baja California Sur',
      },
      {
        id: 'ME_CP',
        description: 'Campeche',
      },
      {
        id: 'ME_CS',
        description: 'Chiapas',
      },
      {
        id: 'ME_CI',
        description: 'Chihuahua',
      },
      {
        id: 'ME_CH',
        description: 'Coahuila',
      },
      {
        id: 'ME_CL',
        description: 'Colima',
      },
      {
        id: 'ME_DF',
        description: 'Districto Federal',
      },
      {
        id: 'ME_DG',
        description: 'Durango',
      },
      {
        id: 'ME_GJ',
        description: 'Guanajuato',
      },
      {
        id: 'ME_GE',
        description: 'Guerrero',
      },
      {
        id: 'ME_HD',
        description: 'Hidalgo',
      },
      {
        id: 'ME_JA',
        description: 'Jalisco',
      },
      {
        id: 'ME_MX',
        description: 'Mexico',
      },
      {
        id: 'ME_MC',
        description: 'Michoacan',
      },
      {
        id: 'ME_MR',
        description: 'Morelos',
      },
      {
        id: 'ME_NA',
        description: 'Nayarit',
      },
      {
        id: 'ME_NL',
        description: 'Nuevo Leon',
      },
      {
        id: 'ME_OA',
        description: 'Oaxaca',
      },
      {
        id: 'ME_PU',
        description: 'Puebla',
      },
      {
        id: 'ME_QE',
        description: 'Queretaro',
      },
      {
        id: 'ME_QI',
        description: 'Quintana Roo',
      },
      {
        id: 'ME_SL',
        description: 'San Luis Potosi',
      },
      {
        id: 'ME_SI',
        description: 'Sinaloa',
      },
      {
        id: 'ME_SO',
        description: 'Sonora',
      },
      {
        id: 'ME_TB',
        description: 'Tabasco',
      },
      {
        id: 'ME_TA',
        description: 'Tamaulipas',
      },
      {
        id: 'ME_TL',
        description: 'Tlaxcala',
      },
      {
        id: 'ME_VC',
        description: 'Veracruz',
      },
      {
        id: 'ME_YU',
        description: 'Yucatan',
      },
      {
        id: 'ME_ZA',
        description: 'Zacatecas',
      },
      {
        id: 'OT_OT',
        description: 'Other',
      },
    ],
    cargoTypes: [
      {
        id: 'property',
        description: 'Property',
      },
      {
        id: 'passanger',
        description: 'Passenger',
      },
    ],
    cycleRuleTypes: [
      {
        id: '70hour',
        description: 'USA 70 hour/8 day',
      },
      {
        id: '60hour',
        description: 'USA 60 hour/7 day',
      },
    ],
    timeZones: [
      {
        id: 'pacific',
        description: 'Pacific Time',
      },
      {
        id: 'mountain',
        description: 'Mountain Time',
      },
      {
        id: 'central',
        description: 'Central Time',
      },
      {
        id: 'eastern',
        description: 'Eastern Time',
      },
    ],
    africaTimeZones: [
      {
        id: 'cat',
        description: 'Eastern European Time',
      },
    ],
    europeTimeZones: [
      {
        id: 'cet',
        description: 'Central Europe Time',
      },
    ],
    odometerUnits: [
      {
        id: 'km',
        description: 'Kilometers (km)',
      },
      {
        id: 'mi',
        description: 'Miles (mi)',
      },
    ],
    fuelTypes: [
      {
        id: 'diesel',
        description: 'enums.staticData.fuelTypes.diesel',
      },
      {
        id: 'gasoline',
        description: 'enums.staticData.fuelTypes.gasoline',
      },
      {
        id: 'propane',
        description: 'enums.staticData.fuelTypes.propane',
      },
      {
        id: 'liquidNG',
        description: 'enums.staticData.fuelTypes.liquidNG',
      },
      {
        id: 'compressedNG',
        description: 'enums.staticData.fuelTypes.compressedNG',
      },
      {
        id: 'ethanol',
        description: 'enums.staticData.fuelTypes.ethanol',
      },
      {
        id: 'methanol',
        description: 'enums.staticData.fuelTypes.methanol',
      },
      {
        id: 'm83',
        description: 'enums.staticData.fuelTypes.m83',
      },
      {
        id: 'm85',
        description: 'enums.staticData.fuelTypes.m85',
      },
      {
        id: 'a55',
        description: 'enums.staticData.fuelTypes.a55',
      },
      {
        id: 'biodiesel',
        description: 'enums.staticData.fuelTypes.biodiesel',
      },
      {
        id: 'other',
        description: 'enums.staticData.fuelTypes.other',
      },
    ],
    inspectionFormTypes: null,
    dutyStatuses: [
      {
        id: 'sleeper',
        description: 'global.dutyStatuses.sleeper',
      },
      {
        id: 'offDuty',
        description: 'global.dutyStatuses.offDuty',
      },
      {
        id: 'personal',
        description: 'global.dutyStatuses.personal',
      },
      {
        id: 'onDuty',
        description: 'global.dutyStatuses.onDuty',
      },
      {
        id: 'driving',
        description: 'global.dutyStatuses.driving',
      },
      {
        id: 'yardMove',
        description: 'global.dutyStatuses.yardMove',
      },
    ],
    violationErrors: [
      {
        id: '30minBreak',
        description: '30 Minutes Break Required',
      },
      {
        id: '11hDriving',
        description: '11 Hour Driving Limit',
      },
      {
        id: '14hShift',
        description: '14 Hour Shift Limit',
      },
      {
        id: '70hCycle',
        description: '70 Hour Cycle Limit',
      },
      {
        id: '60hCycle',
        description: '60 Hour Cycle Limit',
      },
    ],
    driverLogType: [
      {
        id: '',
        description: 'All',
      },
      {
        id: 'withHosViolations',
        description: 'Logs with HOS Violations',
      },
      {
        id: 'withFnMError',
        description: 'Logs with Form and Manner Errors',
      },
    ],
    dailyLogEditHistoryActions: [
      {
        id: 'canceled',
        description: 'Canceled',
      },
      {
        id: 'voided',
        description: 'Voided',
      },
      {
        id: 'approved',
        description: 'Approved',
      },
      {
        id: 'rejected',
        description: 'Rejected',
      },
      {
        id: 'pending',
        description: 'Pending',
      },
    ],
    fleetManagerRoles: [
      {
        id: 'user',
        description: 'User',
      },
      {
        id: 'adminView',
        description: 'Admin (read only)',
      },
      {
        id: 'adminFull',
        description: 'Admin',
      },
    ],
    exportTypes: ['PDF', 'CSV'],
    priorities: [
      {
        id: 'critical',
        description: 'Critical',
      },
      {
        id: 'major',
        description: 'Major',
      },
      {
        id: 'minor',
        description: 'Minor',
      },
    ],
    dvirReportTypes: [
      {
        id: 'preTrip',
        description: 'Pre-Trip',
      },
      {
        id: 'postTrip',
        description: 'Post-Trip',
      },
    ],
    vehicleDvirDefects: [
      {
        id: 'frontHeadlights',
        description: 'Headlights',
      },
      {
        id: 'frontFlashers',
        description: 'Flashers',
      },
      {
        id: 'frontFogLights',
        description: 'Fog Lights',
      },
      {
        id: 'frontMarkerLights',
        description: 'Marker Lights',
      },
      {
        id: 'frontEngineCompartment',
        description: 'Engine Compartment',
      },
      {
        id: 'frontFluids',
        description: 'Fluids',
      },
      {
        id: 'frontBelts',
        description: 'Belts',
      },
      {
        id: 'frontHoses',
        description: 'Hoses',
      },
      {
        id: 'frontCompressor',
        description: 'Compressor',
      },
      {
        id: 'frontBrakes',
        description: 'Brakes',
      },
      {
        id: 'frontSteering',
        description: 'Steering',
      },
      {
        id: 'frontSuspension',
        description: 'Suspension',
      },
      {
        id: 'curbsideFrontAxleMirrors',
        description: 'Mirrors',
      },
      {
        id: 'curbsideFrontAxleTires',
        description: 'Tires',
      },
      {
        id: 'curbsideFrontAxleWheels',
        description: 'Wheels',
      },
      {
        id: 'curbsideRearAxleTires',
        description: 'Tires',
      },
      {
        id: 'curbsideRearAxleBrakes',
        description: 'Brakes',
      },
      {
        id: 'curbsideRearAxleSuspension',
        description: 'Suspension',
      },
      {
        id: 'rearExhaust',
        description: 'Exhaust',
      },
      {
        id: 'rearFifthWheel',
        description: 'Fifth Wheel',
      },
      {
        id: 'rearFrame',
        description: 'Frame',
      },
      {
        id: 'rearLights',
        description: 'Lights',
      },
      {
        id: 'rearFlashers',
        description: 'Flashers',
      },
      {
        id: 'driverRearAxleTires',
        description: 'Tires',
      },
      {
        id: 'driverRearAxleWheels',
        description: 'Wheels',
      },
      {
        id: 'driverRearAxleBrakes',
        description: 'Brakes',
      },
      {
        id: 'driverRearAxleSuspension',
        description: 'Suspension',
      },
      {
        id: 'driverFrontAxleMirrors',
        description: 'Mirrors',
      },
      {
        id: 'driverFrontAxleTires',
        description: 'Tires',
      },
      {
        id: 'driverFrontAxleWheels',
        description: 'Wheels',
      },
      {
        id: 'cabHorn',
        description: 'Horn',
      },
      {
        id: 'cabWipersWashers',
        description: 'Wipers/Washers',
      },
      {
        id: 'cabFireExtinguish',
        description: 'Fire Extinguisher',
      },
      {
        id: 'cabTriangles',
        description: 'Triangles',
      },
      {
        id: 'cabHazMatBook',
        description: 'Haz Mat Book',
      },
      {
        id: 'cabDOTPaperwork',
        description: 'DOT Paperwork',
      },
      {
        id: 'cabBrakesBleedDownTest',
        description: 'Brakes Bleed Down Test',
      },
      {
        id: 'cabBrakesLowAirWarningTest',
        description: 'Brakes Low Air Warning Test',
      },
      {
        id: 'cabTestParkingBrakes',
        description: 'Test Parking Brakes',
      },
      {
        id: 'cabBrakesTestStop1StRotationOfWheels',
        description: 'Brakes Test Stop 1st Rotation of Wheels',
      },
      {
        id: 'cabWindshield',
        description: 'Windshield',
      },
      {
        id: 'frontBumper',
        description: 'Front Bumper',
      },
    ],
    trailerDvirDefects: [
      {
        id: 'trailerBrakeConnections',
        description: 'Brake Connections',
      },
      {
        id: 'trailerBrakes',
        description: 'Brakes',
      },
      {
        id: 'trailerCouplingDevices',
        description: 'Coupling Devices',
      },
      {
        id: 'trailerCouplingPin',
        description: 'Coupling Pin',
      },
      {
        id: 'trailerDoors',
        description: 'Doors',
      },
      {
        id: 'trailerHitch',
        description: 'Hitch',
      },
      {
        id: 'trailerLandingGear',
        description: 'Landing Gear',
      },
      {
        id: 'trailerLights',
        description: 'Lights',
      },
      {
        id: 'trailerReflectors',
        description: 'Reflectors',
      },
      {
        id: 'trailerRoof',
        description: 'Roof',
      },
      {
        id: 'trailerStraps',
        description: 'Straps',
      },
      {
        id: 'trailerSuspensionSystem',
        description: 'Suspension System',
      },
      {
        id: 'trailerTarpaulin',
        description: 'Tarpaulin',
      },
      {
        id: 'trailerTires',
        description: 'Tires',
      },
      {
        id: 'trailerWheelsRims',
        description: 'Wheels & Rims',
      },
      {
        id: 'trailerOther',
        description: 'Other',
      },
      {
        id: 'trailerCargoNet',
        description: 'Cargo Net',
      },
    ],
    eldEventStatuses: [
      {
        id: 'unassigned',
        description: 'unassigned',
      },
      {
        id: 'unidentified',
        description: 'Unidentified',
      },
      {
        id: 'identified',
        description: 'Identified',
      },
    ],
    trailerOwnerships: [
      {
        id: 'company',
        description: 'enums.staticData.trailerOwnerships.company',
      },
      {
        id: 'leased',
        description: 'enums.staticData.trailerOwnerships.leased',
      },
      {
        id: 'contractors',
        description: 'enums.staticData.trailerOwnerships.contractors',
      },
    ],
    trailerSuspensions: [
      {
        id: 'air',
        description: 'Air Ride',
      },
      {
        id: 'spring',
        description: 'Spring Ride',
      },
    ],
    trailerTypes: [
      {
        id: 'dryVan',
        description: 'Dry Van',
      },
      {
        id: 'reefer',
        description: 'Reefer',
      },
      {
        id: 'flatbed',
        description: 'Flatbed',
      },
      {
        id: 'po',
        description: 'PO',
      },
      {
        id: 'conestoga',
        description: 'Conestoga',
      },
    ],
    constructionAssetTypes: [
      {
        id: 'backhoe',
        description: 'Backhoe',
      },
      {
        id: 'bulldozer',
        description: 'Bulldozer',
      },
      {
        id: 'container',
        description: 'Container',
      },
      {
        id: 'crane',
        description: 'Crane',
      },
      {
        id: 'excavator',
        description: 'Excavator',
      },
      {
        id: 'forklift',
        description: 'Forklift',
      },
      {
        id: 'generator',
        description: 'Generator',
      },
      {
        id: 'grader',
        description: 'Grader',
      },
      {
        id: 'light_tower',
        description: 'Light Tower',
      },
      {
        id: 'loader',
        description: 'Loader',
      },
      {
        id: 'mixer',
        description: 'Mixer',
      },
      {
        id: 'mower',
        description: 'Mower',
      },
      {
        id: 'other',
        description: 'Other',
      },
      {
        id: 'roller',
        description: 'Roller',
      },
      {
        id: 'scissor_lift',
        description: 'Scissor Lift',
      },
      {
        id: 'tractor',
        description: 'Tracktor',
      },
    ],
    driverTypes: [
      {
        id: 'companyDriver',
        description: 'enums.staticData.driverTypes.companyDriver',
      },
      {
        id: 'ownerOperator',
        description: 'enums.staticData.driverTypes.ownerOperator',
      },
      {
        id: 'drivingForOwner',
        description: 'enums.staticData.driverTypes.drivingForOwner',
      },
      {
        id: 'leaseToOwnership',
        description: 'enums.staticData.driverTypes.leaseToOwnership',
      },
    ],
    alertTypes: [
      {
        id: 'hos',
        description: null,
      },
      {
        id: 'log',
        description: null,
      },
      {
        id: 'dvir',
        description: null,
      },
      {
        id: 'speed_limit',
        description: null,
      },
      {
        id: 'fault_code',
        description: null,
      },
      {
        id: 'geofenceExit',
        description: null,
      },
      {
        id: 'geofenceEnter',
        description: null,
      },
      {
        id: 'geofenceEntryExit',
        description: null,
      },
    ],
    gpsModelTypes: [
      {
        id: 'round1611',
        description: 'L81611',
      },
      {
        id: 'oval1711',
        description: 'L81711',
      },
      {
        id: 'indash1508',
        description: 'L81508',
      },
      {
        id: 'round2211',
        description: 'L82211',
      },
      {
        id: 'd210',
        description: 'D210',
      },
      {
        id: 'd410',
        description: 'D410',
      },
      {
        id: 'd430',
        description: 'D430',
      },
      {
        id: 'spireonTruck',
        description: 'Truck GPS',
      },
      {
        id: 'spireonTrailer',
        description: 'Trailer GPS',
      },
      {
        id: 'gl520mg',
        description: 'GL520MG - Asset Tracker',
        managerDescription: 'Asset Tracker',
      },
      {
        id: 'gv620mg',
        description: 'GV620MG - Trailer Tracker',
        managerDescription: 'Trailer Tracker',
      },
      {
        id: 'gb130mg',
        description: 'GB130MG - Battery-Mounted Tracker',
        managerDescription: 'Battery-Mounted Tracker',
      },
      {
        id: 'sint229l',
        description: 'SINT229L',
      },
      {
        id: 'eg01g',
        description: 'BSJ EG01G - Rechargeable Asset Tracker',
        managerDescription: 'Rechargeable Asset Tracker',
      },
      {
        id: 'g08l',
        description: 'G08L',
      }
    ],
    maintenanceTypes: [
      {
        id: 'abs',
        description: 'enums.staticData.maintenanceTypes.abs',
        subsets: [],
      },
      {
        id: 'acHeater',
        description: 'enums.staticData.maintenanceTypes.acHeater',
        subsets: [],
      },
      {
        id: 'airLines',
        description: 'enums.staticData.maintenanceTypes.airLines',
        subsets: [],
      },
      {
        id: 'alignment',
        description: 'enums.staticData.maintenanceTypes.alignment',
        subsets: [],
      },
      {
        id: 'axles',
        description: 'enums.staticData.maintenanceTypes.axles',
        subsets: [],
      },
      {
        id: 'battery',
        description: 'enums.staticData.maintenanceTypes.battery',
        subsets: [],
      },
      {
        id: 'bodywork',
        description: 'enums.staticData.maintenanceTypes.bodywork',
        subsets: [],
      },
      {
        id: 'brakes',
        description: 'enums.staticData.maintenanceTypes.brakes',
        subsets: [],
      },
      {
        id: 'coolant',
        description: 'enums.staticData.maintenanceTypes.coolant',
        subsets: [],
      },
      {
        id: 'dot',
        description: 'enums.staticData.maintenanceTypes.dot',
        subsets: [],
      },
      {
        id: 'dpf',
        description: 'enums.staticData.maintenanceTypes.dpf',
        subsets: [],
      },
      {
        id: 'electrical',
        description: 'enums.staticData.maintenanceTypes.electrical',
        subsets: [],
      },
      {
        id: 'engine',
        description: 'enums.staticData.maintenanceTypes.engine',
        subsets: [],
      },
      {
        id: 'filter',
        description: 'enums.staticData.maintenanceTypes.filter',
        subsets: [],
      },
      {
        id: 'fuelSystem',
        description: 'enums.staticData.maintenanceTypes.fuelSystem',
        subsets: [],
      },
      {
        id: 'hoodLatches',
        description: 'enums.staticData.maintenanceTypes.hoodLatches',
        subsets: [],
      },
      {
        id: 'leaseExpiry',
        description: 'enums.staticData.maintenanceTypes.leaseExpiry',
        subsets: [],
      },
      {
        id: 'licenseExpiry',
        description: 'enums.staticData.maintenanceTypes.licenseExpiry',
        subsets: [],
      },
      {
        id: 'lights',
        description: 'enums.staticData.maintenanceTypes.lights',
        subsets: [
          {
            id: 'headlights',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.headlights',
            subsets: [],
          },
          {
            id: 'brakeLights',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.brakeLights',
            subsets: [],
          },
          {
            id: 'markerLights',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.markerLights',
            subsets: [],
          },
          {
            id: 'signalLights',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.signalLights',
            subsets: [],
          },
          {
            id: 'clearanceLights',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.clearanceLights',
            subsets: [],
          },
          {
            id: 'licensePlate',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.licensePlate',
            subsets: [],
          },
          {
            id: 'absLight',
            description:
              'enums.staticData.maintenanceTypes.lightsSubset.absLight',
            subsets: [],
          },
        ],
      },
      {
        id: 'oilChange',
        description: 'enums.staticData.maintenanceTypes.oilChange',
        subsets: [],
      },
      {
        id: 'qls',
        description: 'enums.staticData.maintenanceTypes.qls',
        subsets: [],
      },
      {
        id: 'registrationExpiry',
        description: 'enums.staticData.maintenanceTypes.registrationExpiry',
        subsets: [],
      },
      {
        id: 'shocks',
        description: 'enums.staticData.maintenanceTypes.shocks',
        subsets: [],
      },
      {
        id: 'suspension',
        description: 'enums.staticData.maintenanceTypes.suspension',
        subsets: [
          {
            id: 'leafSprings',
            description:
              'enums.staticData.maintenanceTypes.suspensionSubset.leafSprings',
            subsets: [],
          },
          {
            id: 'shockAbsorbers',
            description:
              'enums.staticData.maintenanceTypes.suspensionSubset.shockAbsorbers',
            subsets: [],
          },
          {
            id: 'bushings',
            description:
              'enums.staticData.maintenanceTypes.suspensionSubset.bushings',
            subsets: [],
          },
          {
            id: 'kingpin',
            description:
              'enums.staticData.maintenanceTypes.suspensionSubset.kingpin',
            subsets: [],
          },
          {
            id: 'tieRod',
            description:
              'enums.staticData.maintenanceTypes.suspensionSubset.tieRod',
            subsets: [],
          },
          {
            id: 'uJoint',
            description:
              'enums.staticData.maintenanceTypes.suspensionSubset.uJoint',
            subsets: [],
          },
        ],
      },
      {
        id: 'sparkPlugs',
        description: 'enums.staticData.maintenanceTypes.sparkPlugs',
        subsets: [],
      },
      {
        id: 'transmission',
        description: 'enums.staticData.maintenanceTypes.transmission',
        subsets: [],
      },
      {
        id: 'towing',
        description: 'enums.staticData.maintenanceTypes.towing',
        subsets: [],
      },
      {
        id: 'tensionerBelt',
        description: 'enums.staticData.maintenanceTypes.tensionerBelt',
        subsets: [],
      },
      {
        id: 'tires',
        description: 'enums.staticData.maintenanceTypes.tires',
        subsets: [
          {
            id: 'steerTire',
            description:
              'enums.staticData.maintenanceTypes.tiresSubset.steerTire',
            subsets: [
              {
                id: 'left',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.steerTireSubset.left',
                subsets: [],
              },
              {
                id: 'right',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.steerTireSubset.right',
                subsets: [],
              },
            ],
          },
          {
            id: 'driveTire',
            description:
              'enums.staticData.maintenanceTypes.tiresSubset.driveTire',
            subsets: [
              {
                id: 'd_lfo',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_lfo',
                subsets: [],
              },
              {
                id: 'd_lfi',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_lfi',
                subsets: [],
              },
              {
                id: 'd_lro',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_lro',
                subsets: [],
              },
              {
                id: 'd_lri',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_lri',
                subsets: [],
              },
              {
                id: 'd_rfo',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_rfo',
                subsets: [],
              },
              {
                id: 'd_rfi',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_rfi',
                subsets: [],
              },
              {
                id: 'd_rro',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_rro',
                subsets: [],
              },
              {
                id: 'd_rri',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.driveTireSubset.d_rri',
                subsets: [],
              },
            ],
          },
          {
            id: 'trailerTire',
            description:
              'enums.staticData.maintenanceTypes.tiresSubset.trailerTire',
            subsets: [
              {
                id: 't_lfo',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_lfo',
                subsets: [],
              },
              {
                id: 't_lfi',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_lfi',
                subsets: [],
              },
              {
                id: 't_lro',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_lro',
                subsets: [],
              },
              {
                id: 't_lri',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_lri',
                subsets: [],
              },
              {
                id: 't_rfo',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_rfo',
                subsets: [],
              },
              {
                id: 't_rfi',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_rfi',
                subsets: [],
              },
              {
                id: 't_rro',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_rro',
                subsets: [],
              },
              {
                id: 't_rri',
                description:
                  'enums.staticData.maintenanceTypes.tiresSubset.trailerTireSubset.t_rri',
                subsets: [],
              },
            ],
          },
        ],
      },
      {
        id: 'waterPump',
        description: 'enums.staticData.maintenanceTypes.waterPump',
        subsets: [],
      },
      {
        id: 'wheelSeal',
        description: 'enums.staticData.maintenanceTypes.wheelSeal',
        subsets: [],
      },
      {
        id: 'windshield',
        description: 'enums.staticData.maintenanceTypes.windshield',
        subsets: [],
      },
      {
        id: 'other',
        description: 'enums.staticData.maintenanceTypes.other',
        subsets: [],
      },
      {
        id: 'annualDot',
        description: 'enums.staticData.maintenanceTypes.annualDot',
        subsets: [],
      },
      {
        id: 'pm',
        description: 'enums.staticData.maintenanceTypes.pm',
        subsets: [],
      },
      {
        id: 'batteries',
        description: 'enums.staticData.maintenanceTypes.batteries',
        subsets: [],
      },
      {
        id: 'medium',
        description: 'enums.staticData.maintenanceTypes.medium',
        subsets: [],
      },
    ],
    scheduleMaintenanceTypes: [
      {
        id: 'acHeater',
        description: 'enums.staticData.scheduleMaintenanceTypes.acHeater',
        subsets: [],
      },
      {
        id: 'axles',
        description: 'enums.staticData.scheduleMaintenanceTypes.axles',
        subsets: [],
      },
      {
        id: 'battery',
        description: 'enums.staticData.scheduleMaintenanceTypes.battery',
        subsets: [],
      },
      {
        id: 'brakes',
        description: 'enums.staticData.scheduleMaintenanceTypes.brakes',
        subsets: [],
      },
      {
        id: 'engine',
        description: 'enums.staticData.scheduleMaintenanceTypes.engine',
        subsets: [],
      },
      {
        id: 'filter',
        description: 'enums.staticData.scheduleMaintenanceTypes.filter',
        subsets: [],
      },
      {
        id: 'leaseExpiry',
        description: 'enums.staticData.scheduleMaintenanceTypes.leaseExpiry',
        subsets: [],
      },
      {
        id: 'licenseExpiry',
        description: 'enums.staticData.scheduleMaintenanceTypes.licenseExpiry',
        subsets: [],
      },
      {
        id: 'oilChange',
        description: 'enums.staticData.scheduleMaintenanceTypes.oilChange',
        subsets: [],
      },
      {
        id: 'registrationExpiry',
        description:
          'enums.staticData.scheduleMaintenanceTypes.registrationExpiry',
        subsets: [],
      },
      {
        id: 'sparkPlugs',
        description: 'enums.staticData.scheduleMaintenanceTypes.sparkPlugs',
        subsets: [],
      },
      {
        id: 'tires',
        description: 'enums.staticData.scheduleMaintenanceTypes.tires',
        subsets: [
          {
            id: 'steerTire',
            description:
              'enums.staticData.scheduleMaintenanceTypes.tiresSubset.steerTire',
            subsets: [
              {
                id: 'left',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.steerTireSubset.left',
                subsets: [],
              },
              {
                id: 'right',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.steerTireSubset.right',
                subsets: [],
              },
            ],
          },
          {
            id: 'driveTire',
            description:
              'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTire',
            subsets: [
              {
                id: 'd_lfo',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_lfo',
                subsets: [],
              },
              {
                id: 'd_lfi',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_lfi',
                subsets: [],
              },
              {
                id: 'd_lro',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_lro',
                subsets: [],
              },
              {
                id: 'd_lri',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_lri',
                subsets: [],
              },
              {
                id: 'd_rfo',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_rfo',
                subsets: [],
              },
              {
                id: 'd_rfi',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_rfi',
                subsets: [],
              },
              {
                id: 'd_rro',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_rro',
                subsets: [],
              },
              {
                id: 'd_rri',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.driveTireSubset.d_rri',
                subsets: [],
              },
            ],
          },
          {
            id: 'trailerTire',
            description:
              'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTire',
            subsets: [
              {
                id: 't_lfo',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_lfo',
                subsets: [],
              },
              {
                id: 't_lfi',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_lfi',
                subsets: [],
              },
              {
                id: 't_lro',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_lro',
                subsets: [],
              },
              {
                id: 't_lri',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_lri',
                subsets: [],
              },
              {
                id: 't_rfo',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_rfo',
                subsets: [],
              },
              {
                id: 't_rfi',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_rfi',
                subsets: [],
              },
              {
                id: 't_rro',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_rro',
                subsets: [],
              },
              {
                id: 't_rri',
                description:
                  'enums.staticData.scheduleMaintenanceTypes.tiresSubset.trailerTireSubset.t_rri',
                subsets: [],
              },
            ],
          },
        ],
      },
      {
        id: 'other',
        description: 'enums.staticData.scheduleMaintenanceTypes.other',
        subsets: [],
      },
      {
        id: 'annualDot',
        description: 'enums.staticData.scheduleMaintenanceTypes.annualDot',
        subsets: [],
      },
      {
        id: 'pm',
        description: 'enums.staticData.scheduleMaintenanceTypes.pm',
        subsets: [],
      },
      {
        id: 'batteries',
        description: 'enums.staticData.scheduleMaintenanceTypes.batteries',
        subsets: [],
      },
      {
        id: 'medium',
        description: 'enums.staticData.scheduleMaintenanceTypes.medium',
        subsets: [],
      },
    ],
    repairAndFaultMaintenanceTypes: [
      {
        id: 'abs',
        description: 'ABS',
        subsets: [],
      },
      {
        id: 'acHeater',
        description: 'AC & Heater',
        subsets: [],
      },
      {
        id: 'airLines',
        description: 'Air Lines',
        subsets: [],
      },
      {
        id: 'alignment',
        description: 'Alignment',
        subsets: [],
      },
      {
        id: 'axles',
        description: 'Axles',
        subsets: [],
      },
      {
        id: 'battery',
        description: 'Battery',
        subsets: [],
      },
      {
        id: 'bodywork',
        description: 'Bodywork',
        subsets: [],
      },
      {
        id: 'brakes',
        description: 'Brakes',
        subsets: [],
      },
      {
        id: 'coolant',
        description: 'Coolant',
        subsets: [],
      },
      {
        id: 'dot',
        description: 'DOT',
        subsets: [],
      },
      {
        id: 'dpf',
        description: 'DPF',
        subsets: [],
      },
      {
        id: 'electrical',
        description: 'Electrical',
        subsets: [],
      },
      {
        id: 'engine',
        description: 'Engine',
        subsets: [],
      },
      {
        id: 'filter',
        description: 'Filter',
        subsets: [],
      },
      {
        id: 'fuelSystem',
        description: 'Fuel System',
        subsets: [],
      },
      {
        id: 'hoodLatches',
        description: 'Hood Latches',
        subsets: [],
      },
      {
        id: 'leaseExpiry',
        description: 'Lease Expiry',
        subsets: [],
      },
      {
        id: 'licenseExpiry',
        description: 'License Expiry',
        subsets: [],
      },
      {
        id: 'lights',
        description: 'Lights',
        subsets: [
          {
            id: 'headlights',
            description: 'Headlights',
            subsets: [],
          },
          {
            id: 'brakeLights',
            description: 'Brake lights',
            subsets: [],
          },
          {
            id: 'markerLights',
            description: 'Marker lights',
            subsets: [],
          },
          {
            id: 'signalLights',
            description: 'Signal lights',
            subsets: [],
          },
          {
            id: 'clearanceLights',
            description: 'Clearance lights',
            subsets: [],
          },
          {
            id: 'licensePlate',
            description: 'License plate',
            subsets: [],
          },
          {
            id: 'absLight',
            description: 'ABS lights',
            subsets: [],
          },
        ],
      },
      {
        id: 'oilChange',
        description: 'Oil Change',
        subsets: [],
      },
      {
        id: 'qls',
        description: 'QLS',
        subsets: [],
      },
      {
        id: 'registrationExpiry',
        description: 'Registration Expiry',
        subsets: [],
      },
      {
        id: 'shocks',
        description: 'Shocks',
        subsets: [],
      },
      {
        id: 'suspension',
        description: 'Suspension',
        subsets: [
          {
            id: 'leafSprings',
            description: 'Leaf springs',
            subsets: [],
          },
          {
            id: 'shockAbsorbers',
            description: 'Shock absorbers',
            subsets: [],
          },
          {
            id: 'bushings',
            description: 'Bushings',
            subsets: [],
          },
          {
            id: 'kingpin',
            description: 'Kingpin',
            subsets: [],
          },
          {
            id: 'tieRod',
            description: 'Tie Rod',
            subsets: [],
          },
          {
            id: 'uJoint',
            description: 'U-joint',
            subsets: [],
          },
        ],
      },
      {
        id: 'sparkPlugs',
        description: 'Spark Plugs',
        subsets: [],
      },
      {
        id: 'transmission',
        description: 'Transmission',
        subsets: [],
      },
      {
        id: 'towing',
        description: 'Towing',
        subsets: [],
      },
      {
        id: 'tensionerBelt',
        description: 'Tensioner & Belt',
        subsets: [],
      },
      {
        id: 'tires',
        description: 'Tires',
        subsets: [
          {
            id: 'steerTire',
            description: 'Steer Tyre',
            subsets: [
              {
                id: 'left',
                description: 'Left',
                subsets: [],
              },
              {
                id: 'right',
                description: 'Right',
                subsets: [],
              },
            ],
          },
          {
            id: 'driveTire',
            description: 'Drive Tyre',
            subsets: [
              {
                id: 'd_lfo',
                description: 'LFO',
                subsets: [],
              },
              {
                id: 'd_lfi',
                description: 'LFI',
                subsets: [],
              },
              {
                id: 'd_lro',
                description: 'LRO',
                subsets: [],
              },
              {
                id: 'd_lri',
                description: 'LRI',
                subsets: [],
              },
              {
                id: 'd_rfo',
                description: 'RFO',
                subsets: [],
              },
              {
                id: 'd_rfi',
                description: 'RFI',
                subsets: [],
              },
              {
                id: 'd_rro',
                description: 'RRO',
                subsets: [],
              },
              {
                id: 'd_rri',
                description: 'RRI',
                subsets: [],
              },
            ],
          },
          {
            id: 'trailerTire',
            description: 'Trailer Tyre',
            subsets: [
              {
                id: 't_lfo',
                description: 'LFO',
                subsets: [],
              },
              {
                id: 't_lfi',
                description: 'LFI',
                subsets: [],
              },
              {
                id: 't_lro',
                description: 'LRO',
                subsets: [],
              },
              {
                id: 't_lri',
                description: 'LRI',
                subsets: [],
              },
              {
                id: 't_rfo',
                description: 'RFO',
                subsets: [],
              },
              {
                id: 't_rfi',
                description: 'RFI',
                subsets: [],
              },
              {
                id: 't_rro',
                description: 'RRO',
                subsets: [],
              },
              {
                id: 't_rri',
                description: 'RRI',
                subsets: [],
              },
            ],
          },
        ],
      },
      {
        id: 'waterPump',
        description: 'Water Pump',
        subsets: [],
      },
      {
        id: 'wheelSeal',
        description: 'Wheel Seal',
        subsets: [],
      },
      {
        id: 'windshield',
        description: 'Windshield',
        subsets: [],
      },
      {
        id: 'other',
        description: 'Other',
        subsets: [],
      },
    ],
    maintenanceFrequencyTypes: [
      {
        id: 'days',
        description: 'days',
      },
      {
        id: 'miles',
        description: 'miles',
      },
      {
        id: 'engineHours',
        description: 'engine hours',
      },
    ],
    billingStatuses: [
      {
        id: 'active',
        description: 'Active',
      },
      {
        id: 'testing',
        description: 'Testing',
      },
      {
        id: 'freeTrial',
        description: 'Free Trial',
      },
      {
        id: 'deactivated',
        description: 'Deactivated',
      },
    ],
    geofenceShapes: [
      {
        id: 'rectangle',
        description: 'Rectangle',
      },
      {
        id: 'polygon',
        description: 'Polygon',
      },
      {
        id: 'circle',
        description: 'Circle',
      },
    ],
    geofenceTypes: [
      {
        id: 'basicGeofence',
        description: 'Basic Geofence',
      },
      {
        id: 'fuelStation',
        description: 'Fuel Station',
      },
      {
        id: 'restrictedLocation',
        description: 'Restricted Location',
      },
      {
        id: 'riskZone',
        description: 'Risk Zone',
      },
      {
        id: 'weightStation',
        description: 'Weigh Station',
      },
      {
        id: 'yard',
        description: 'Yard',
      },
      {
        id: 'uncategorized',
        description: 'Uncategorized',
      },
    ],
    geofenceAlertTypes: null,
    groupAlertTypes: [],
    specialStatuses: [
      {
        id: 'personal',
        description: 'Personal',
      },
      {
        id: 'yardMove',
        description: 'Yard Move',
      },
      {
        id: 'advancedSettings',
        description: 'Advanced Settings',
      },
      {
        id: 'driverSupport',
        description: 'Driver Support',
      },
    ],
    adminUserTypes: [
      {
        id: 'accounting',
        description: 'Accounting Person',
      },
      {
        id: 'sales',
        description: 'Sales Person',
      },
      {
        id: 'technical',
        description: 'Technical Person',
      },
      {
        id: 'reseller',
        description: 'Reseller',
      },
    ],
    alertRecipientTypes: [
      {
        id: 'sms',
        description: 'SMS',
      },
      {
        id: 'email',
        description: 'Email',
      },
      {
        id: 'app',
        description: 'APP',
      },
    ],
    eldManufacturers: [
      {
        id: 'geometris',
        description: 'Geometris',
      },
      {
        id: 'iosix',
        description: 'IOSix',
      },
      {
        id: 'pacific_track',
        description: 'Pacific Track',
      },
      {
        id: 'howen',
        description: 'Howen',
      },
      {
        id: 'queclink',
        description: 'Queclink',
      },
    ],
    gpsManufacturers: [
      {
        id: 'anytrek',
        description: 'AnyTrek',
      },
      {
        id: 'bsj',
        description: 'BSJ',
      },
      {
        id: 'cantrack',
        description: 'Cantrack',
      },
      {
        id: 'netradyne',
        description: 'Netradyne',
      },
      {
        id: 'spireon',
        description: 'Spireon',
      },
      {
        id: 'queclink',
        description: 'Queclink',
      },
      {
        id: 'sinocastel',
        description: 'Sinocastel',
      },
    ],
    externalIntegrations: [
      {
        id: 'netradyne',
        description: 'Netradyne',
      },
      {
        id: 'truckStop',
        description: 'Truck Stop',
      },
      {
        id: 'truckerTools',
        description: 'Trucker Tools',
      },
    ],
    supportTypes: [
      {
        id: 'switch',
        description: 'Switch',
      },
      {
        id: 'urgentSwitch',
        description: 'Urgent Switch',
      },
      {
        id: 'nonUrgentSwitch',
        description: 'Non-urgent Switch',
      },
      {
        id: 'advancedShrinkSlide',
        description: 'A Shrink/Slide',
      },
      {
        id: 'urgentAdvancedShrinkSlide',
        description: 'Urgent A Shrink/Slide',
      },
      {
        id: 'nonUrgentAdvancedShrinkSlide',
        description: 'Non-urgent A Shrink/Slide',
      },
      {
        id: 'premiumShrinkSlide',
        description: 'P Shrink/Slide',
      },
      {
        id: 'urgentPremiumShrinkSlide',
        description: 'Urgent P Shrink/Slide',
      },
      {
        id: 'nonUrgentPremiumShrinkSlide',
        description: 'Non-urgent P Shrink/Slide',
      },
      {
        id: 'partialSwitch',
        description: 'Partial Switch',
      },
      {
        id: 'checker',
        description: 'Checker',
      },
      {
        id: 'unidentifiedDrivingFix',
        description: 'Unidentified Driving Fix',
      },
      {
        id: 'unidentifiedDrivingCall',
        description: 'Unidentified Driving Call',
      },
      {
        id: 'hosViolationFix',
        description: 'HOS Violation Fix',
      },
      {
        id: 'hosViolationCall',
        description: 'HOS Violation Call',
      },
      {
        id: 'nearHOSViolationCall',
        description: 'Near HOS violation Call',
      },
      {
        id: '30minBreakViolation',
        description: '30 Minutes Break Violation',
      },
      {
        id: '11hDrivingViolation',
        description: '11 Hour Driving Violation',
      },
      {
        id: '14hShiftViolation',
        description: '14 Hour Shift Violation',
      },
      {
        id: 'cycleViolation',
        description: 'Cycle Violation',
      },
      {
        id: 'formAndMannerFix',
        description: 'Form and Manner Fix',
      },
      {
        id: 'reassignDriving',
        description: 'Reassign Driving',
      },
      {
        id: 'info',
        description: 'Info',
      },
      {
        id: 'eldUnpluggedFix',
        description: 'ELD Unplugged Fix',
      },
      {
        id: 'eldUnpluggedCall',
        description: 'ELD Unplugged Call',
      },
      {
        id: 'ptiMissing',
        description: 'PTI Missing',
      },
      {
        id: 'pc',
        description: 'PC',
      },
      {
        id: 'malfunctionLetter',
        description: 'Malfunction Letter',
      },
      {
        id: 'ym',
        description: 'Yard move',
      },
      {
        id: 'fleetManagerRequest',
        description: 'Fleet Manager Request',
      },
      {
        id: 'other',
        description: 'Other',
      },
    ],
    documentTypes: [
      {
        id: '',
        description: 'All',
      },
      {
        id: 'accidentPhoto',
        description: 'Accident Photo',
      },
      {
        id: 'billOfLading',
        description: 'Bill of Lading',
      },
      {
        id: 'dotInspection',
        description: 'DOT Inspection',
      },
      {
        id: 'scaleTicket',
        description: 'Scale Ticket',
      },
      {
        id: 'other',
        description: 'Other',
      },
    ],
    loadTypes: [
      {
        id: 'All',
        description: 'All Load Types',
      },
      {
        id: 'Full',
        description: 'Full',
      },
      {
        id: 'Partial',
        description: 'Partial',
      },
    ],
    equipmentTypes: [
      {
        id: 'ANY',
        description: 'Any Equipment',
      },
      {
        id: 'V',
        description: 'VAN',
      },
      {
        id: 'F',
        description: 'Flatbed',
      },
      {
        id: 'PO',
        description: 'Power Only (tow-away)',
      },
      {
        id: 'R',
        description: 'Refrigerated (Reefer)',
      },
      {
        id: '2F',
        description: 'Two 24 or 28 foot flats',
      },
      {
        id: 'ANIM',
        description: 'Animal Carrier',
      },
      {
        id: 'AUTO',
        description: 'Auto Carrier',
      },
      {
        id: 'BDMP',
        description: 'Belly Dump',
      },
      {
        id: 'BEAM',
        description: 'Beam',
      },
      {
        id: 'BELT',
        description: 'Conveyor Belt',
      },
      {
        id: 'BOAT',
        description: 'Boat Hauling Trailer',
      },
      {
        id: 'CH',
        description: 'Convertible Hopper',
      },
      {
        id: 'CONG',
        description: 'Conestoga',
      },
      {
        id: 'CONT',
        description: 'Container Trailer',
      },
      {
        id: 'CV',
        description: 'Curtain Van',
      },
      {
        id: 'DA',
        description: 'Drive Away',
      },
      {
        id: 'DD',
        description: 'Double Drop',
      },
      {
        id: 'DDE',
        description: 'Double Drop Extendable',
      },
      {
        id: 'DUMP',
        description: 'Dump Trucks',
      },
      {
        id: 'ENDP',
        description: 'End Dump',
      },
      {
        id: 'FA',
        description: 'Flatbed Air-Ride',
      },
      {
        id: 'FEXT',
        description: 'Stretch Trailers or Extendable Flatbed',
      },
      {
        id: 'FINT',
        description: 'Flatbed Intermodal',
      },
      {
        id: 'FO',
        description: 'Flatbed over-dimension loads',
      },
      {
        id: 'FRV',
        description: 'Flatbed, Van, or Reefer',
      },
      {
        id: 'FVV',
        description: 'Flatbed, or Vented Van',
      },
      {
        id: 'FVVR',
        description: 'Flatbed, Vented Van or Reefer',
      },
      {
        id: 'FWS',
        description: 'Flatbed With Sides',
      },
      {
        id: 'HOPP',
        description: 'Hopper Bottom',
      },
      {
        id: 'HS',
        description: 'Hot Shot',
      },
      {
        id: 'HTU',
        description: 'Haul and Tow Unit',
      },
      {
        id: 'LAF',
        description: 'Landoll Flatbed',
      },
      {
        id: 'LB',
        description: 'Lowboy',
      },
      {
        id: 'LBO',
        description: 'Lowboy over-dimension load',
      },
      {
        id: 'LDOT',
        description: 'Load-Out are empty trailers you load and haul',
      },
      {
        id: 'LIVE',
        description: 'Live Bottom Trailer',
      },
      {
        id: 'MAXI',
        description: 'Maxi or Double Flat Trailers',
      },
      {
        id: 'MBHM',
        description: 'Mobile Home',
      },
      {
        id: 'PNEU',
        description: 'Pneumatic',
      },
      {
        id: 'RGN',
        description: 'Removable Goose Neck & Multi-Axle Heavy Haulers',
      },
      {
        id: 'RGNE',
        description: 'RGN Extendable',
      },
      {
        id: 'RINT',
        description: 'Refrigerated Intermodal',
      },
      {
        id: 'ROLL',
        description: 'Roll Top Conestoga',
      },
      {
        id: 'RPD',
        description: 'Refrigerated Carrier W/Plant Decking',
      },
      {
        id: 'RV',
        description: 'Van or Reefer',
      },
      {
        id: 'SD',
        description: 'Step Deck',
      },
      {
        id: 'SDL',
        description: 'Step Deck w/Loading Ramps ',
      },
      {
        id: 'SDO',
        description: 'Step Deck over-dimension load',
      },
      {
        id: 'SDRG',
        description: 'Step Deck or Removable Gooseneck',
      },
      {
        id: 'SPEC',
        description: 'Unspecified Specialized Trailers',
      },
      {
        id: 'SV',
        description: 'Straight Van',
      },
      {
        id: 'TANK',
        description:
          'Tanker (Please specify Food grade, liquid, bulk, etc. in your posting)',
      },
      {
        id: 'V-OT',
        description: 'Open Top Van',
      },
      {
        id: 'VA',
        description: 'Van Air-Ride',
      },
      {
        id: 'VB',
        description: 'Blanket Wrap Van',
      },
      {
        id: 'VCAR',
        description: 'Cargo Vans (1 Ton capacity)',
      },
      {
        id: 'VF',
        description: 'Flatbed or Van',
      },
      {
        id: 'VINT',
        description: 'Van Intermodal',
      },
      {
        id: 'VIV',
        description: 'Vented Insulated Van',
      },
      {
        id: 'VIVR',
        description: 'Vented Insulated Van or Refrigerated',
      },
      {
        id: 'VLG',
        description: 'Van w/Liftgate',
      },
      {
        id: 'VM',
        description: 'Moving Van',
      },
      {
        id: 'VRDD',
        description: 'Van, Reefer Double Drop',
      },
      {
        id: 'VV',
        description: 'Vented Van',
      },
      {
        id: 'VVR',
        description: 'Vented Van or Refrigerated',
      },
      {
        id: 'WALK',
        description: 'Walking Floor',
      },
    ],
    trailerOptionTypes: [
      {
        id: 'Tarps',
        description: 'Tarps',
      },
      {
        id: 'Hazardous',
        description: 'Hazardous',
      },
      {
        id: 'PalletExchange',
        description: 'PalletExchange',
      },
      {
        id: 'Team',
        description: 'Team',
      },
      {
        id: 'Expedited',
        description: 'Expedited',
      },
    ],
    cameraStatuses: [
      {
        id: 'active',
        description: 'Active',
      },
      {
        id: 'deactivated',
        description: 'Deactivated',
      },
      {
        id: 'replaced',
        description: 'Replaced',
      },
      {
        id: 'onHold',
        description: 'On Hold',
      },
      {
        id: 'unassigned',
        description: 'Unassigned',
      },
      {
        id: 'freeTrial',
        description: 'Free Trial',
      },
    ],
    cameraBillingStatuses: [
      {
        id: 'serviceOnly',
        description: 'Service Only',
      },
      {
        id: 'bundleFee',
        description: 'Bundle Fee',
      },
      {
        id: 'unassigned',
        description: 'Unassigned',
      },
    ],
    cameraManufacturers: [
      {
        id: 'howen',
        description: 'Howen',
      },
      {
        id: 'netradyne',
        description: 'Netradyne',
      },
      {
        id: 'streamax',
        description: 'Streamax',
      },
    ],
    dueInTypes: [
      {
        id: 'overdue',
        description: 'Overdue',
      },
      {
        id: 'dueSoon',
        description: 'Due Soon',
      },
      {
        id: 'upcoming',
        description: 'Upcoming',
      },
    ],
    cameraAlarmTypes: [
      {
        id: 118,
        description: 'enums.staticData.cameraAlarmTypes.distractedDriving',
        severity: 'MINOR',
      },
      {
        id: 24,
        description: 'enums.staticData.cameraAlarmTypes.harshAcceleration',
        severity: 'MAJOR',
      },
      {
        id: 25,
        description: 'enums.staticData.cameraAlarmTypes.harshBrake',
        severity: 'MAJOR',
      },
      {
        id: 102,
        description: 'enums.staticData.cameraAlarmTypes.laneDeparture',
        severity: 'CRITICAL',
      },
      {
        id: 101,
        description: 'enums.staticData.cameraAlarmTypes.forwardCollisionWarning',
        severity: 'CRITICAL',
      },
      {
        id: 103,
        description: 'enums.staticData.cameraAlarmTypes.tailgating',
        severity: 'MAJOR',
      },
      {
        id: 116,
        description: 'enums.staticData.cameraAlarmTypes.phoneUsage',
        severity: 'MAJOR',
      },
      {
        id: 117,
        description: 'enums.staticData.cameraAlarmTypes.smoking',
        severity: 'MAJOR',
      },
      {
        id: 122,
        description: 'enums.staticData.cameraAlarmTypes.yawning',
        severity: 'MAJOR',
      },
    ],
    cameraAlarmSeverity: [
      {
        id: 'critical',
        description: 'Critical',
      },
      {
        id: 'major',
        description: 'Major',
      },
      {
        id: 'minor',
        description: 'Minor',
      },
    ],
    cameraAlarmStatuses: [
      {
        id: 'pending',
        description: 'Pending',
      },
      {
        id: 'approved',
        description: 'Approved',
      },
      {
        id: 'rejected',
        description: 'Rejected',
      },
    ],
    cameraViews: [
      {
        id: '2',
        description: 'enums.staticData.cameraViews.frontRoad',
      },
      {
        id: '1',
        description: 'enums.staticData.cameraViews.backCabin',
      },
    ],
    cameraRequestedVideoStatus: [
      {
        id: 'ready',
        description: 'Ready',
      },
      {
        id: 'pending',
        description: 'Pending',
      },
      {
        id: 'notStarted',
        description: 'Not Started',
      },
      {
        id: 'inProgress',
        description: 'In Progress',
      },
      {
        id: 'paused',
        description: 'Paused',
      },
      {
        id: 'unavailable',
        description: 'Unavailable',
      },
    ],
    availableTrucksEquipment: [
      {
        id: 'boxTruck',
        description: 'enums.staticData.availableTrucksEquipment.boxTruck',
      },
      {
        id: 'flatbed',
        description: 'enums.staticData.availableTrucksEquipment.flatbed',
      },
      {
        id: 'flatbedTeam',
        description: 'enums.staticData.availableTrucksEquipment.flatbedTeam',
      },
      {
        id: 'reefer',
        description: 'enums.staticData.availableTrucksEquipment.reefer',
      },
      {
        id: 'reeferTeam',
        description: 'enums.staticData.availableTrucksEquipment.reeferTeam',
      },
      {
        id: 'straightTrucks',
        description: 'enums.staticData.availableTrucksEquipment.straightTrucks',
      },
      {
        id: 'straightTruckTeam',
        description:
          'enums.staticData.availableTrucksEquipment.straightTruckTeam',
      },
      {
        id: 'van',
        description: 'enums.staticData.availableTrucksEquipment.van',
      },
      {
        id: 'vanTeam',
        description: 'enums.staticData.availableTrucksEquipment.vanTeam',
      },
    ],
    tickTypes: [
      {
        id: 'eldLogin',
        description: 'ELD Login',
      },
      {
        id: 'eldLogout',
        description: 'ELD Logout',
      },
      {
        id: 'intermediate',
        description: 'Intermediate',
      },
      {
        id: 'powerUp',
        description: 'Power Up',
      },
      {
        id: 'shutDown',
        description: 'Shut Down',
      },
    ],
    simManufacturers: [
      {
        id: 'teal',
        description: 'Teal',
      },
      {
        id: '1nce',
        description: '1NCE',
      },
    ],
    accessoriesStatuses: [
      {
        id: 'active',
        description: 'Active',
      },
      {
        id: 'deactivated',
        description: 'Deactivated',
      },
      {
        id: 'replaced',
        description: 'Replaced',
      },
      {
        id: 'unassigned',
        description: 'Unassigned',
      },
      {
        id: 'freeTrial',
        description: 'Free Trial',
      },
    ],
    accessoriesTypes: [
      {
        id: 'environmentSensor',
        description: 'Temperature and Humidity Sensor',
        managerDescription: 'Temperature and Humidity Sensor',
      },
      {
        id: 'doorMonitor',
        description: 'Door Sensor',
        managerDescription: 'Door Sensor',
      },
      {
        id: 'engineImmobilizer',
        description: 'Engine Immobilizer',
      },
      {
        id: 'eldBeacon',
        description: 'ELD Beacon',
      },
      {
        id: 'gpsBeacon',
        description: 'GPS Beacon',
      },
    ],
    accessoriesAlerts: [
      {
        id: 'temperatureDropped',
        description: null,
      },
      {
        id: 'temperatureExceeded',
        description: null,
      },
      {
        id: 'humidityDropped',
        description: null,
      },
      {
        id: 'humidityExceeded',
        description: null,
      },
      {
        id: 'trailerDoorOpened',
        description: null,
      },
    ],
    activityAssetTypes: [
      {
        id: 'vehicles',
        description: 'Vehicles',
      },
      {
        id: 'trailers',
        description: 'Assets',
      },
      {
        id: 'drivers',
        description: 'Drivers',
      },
      {
        id: 'fleetManagers',
        description: 'Fleet Managers',
      },
      {
        id: 'geofences',
        description: 'Geofences'
      },
      {
        id: 'alerts',
        description: 'Alerts',
      }
    ],
    adminActivityAssetTypes: [
      {
        id: 'companies',
        description: ADMIN_ACTIVITY_ASSET_TYPES.companies,
      },
      {
        id: 'elds',
        description: ADMIN_ACTIVITY_ASSET_TYPES.elds,
      },
      {
        id: 'gpss',
        description: ADMIN_ACTIVITY_ASSET_TYPES.gpss,
      },
      {
        id: 'accessories',
        description: ADMIN_ACTIVITY_ASSET_TYPES.accessories,
      },
      {
        id: 'cameras',
        description: ADMIN_ACTIVITY_ASSET_TYPES.cameras,
      },
    ],
    adminActivityFilterTypes: [
      {
        id: 'statusChange',
        description: 'Status Change',
      },
      {
        id: 'companyChange',
        description: 'Company Change',
      },
      {
        id: 'edit',
        description: 'Edit',
      },
      {
        id: 'add',
        description: 'Add',
      },
      {
        id: 'delete',
        description: 'Delete',
      },
    ],
    adminActivityStatuses: [
      {
        id: 'open',
        description: 'Open',
      },
      {
        id: 'done',
        description: 'Done',
      },
    ],
    speedingSettingsThresholdValues: [
      {
        id: 1,
        description: '1-5 mph',
      },
      {
        id: 5,
        description: '6-10 mph',
      },
      {
        id: 10,
        description: '11-14 mph',
      },
      {
        id: 15,
        description: '15+ mph',
      },
    ],
    speedingSettingsSpeedingLevels: [
      {
        id: 'minorDuration',
        description: 'Minor',
      },
      {
        id: 'moderateDuration',
        description: 'Moderate',
      },
      {
        id: 'severeDuration',
        description: 'Severe',
      },
      {
        id: 'criticalDuration',
        description: 'Critical',
      },
    ],
    speedingSettingsDurationValues: [
      {
        id: 20,
        description: '20 seconds',
      },
      {
        id: 60,
        description: '60 seconds',
      },
      {
        id: 2 * 60,
        description: '2 minutes',
      },
      {
        id: 5 * 60,
        description: '5 minutes',
      },
    ],
    vehicleTypes: [
      {
        id: 'truck',
        description: 'enums.staticData.vehicleTypes.truck',
      },
      {
        id: 'bus',
        description: 'enums.staticData.vehicleTypes.bus',
      },
      {
        id: 'van',
        description: 'enums.staticData.vehicleTypes.van',
      },
      {
        id: 'car',
        description: 'enums.staticData.vehicleTypes.car',
      },
    ],
    assetTypes: [
      {
        id: 'trailer',
        description: 'enums.staticData.assetTypes.trailer',
      },
      {
        id: 'construction',
        description: 'enums.staticData.assetTypes.construction',
      },
      {
        id: 'other',
        description: 'enums.staticData.assetTypes.other',
      },
    ],
    companyRegions: [
      {
        id: 'usa',
        description: 'USA',
      },
      {
        id: 'africa',
        description: 'Africa',
      },
      {
        id: 'europe',
        description: 'Europe',
      },
    ],
    pingFrequencyOptions: [
      { id: '10minutes', description: 'enums.staticData.pingFrequencyOptions.10m' },
      { id: '15minutes', description: 'enums.staticData.pingFrequencyOptions.15m' },
      { id: '30minutes', description: 'enums.staticData.pingFrequencyOptions.30m' },
      { id: '1hour', description: 'enums.staticData.pingFrequencyOptions.1h' },
      { id: '2hours', description: 'enums.staticData.pingFrequencyOptions.2h' },
      { id: '6hours', description: 'enums.staticData.pingFrequencyOptions.6h' },
      { id: '12hours', description: 'enums.staticData.pingFrequencyOptions.12h' },
      { id: '24hours', description: 'enums.staticData.pingFrequencyOptions.24h' },
    ],
  };
  return {
    ...initialState,
    ...data,
  };
};

export function reducer(
  state = loadInitialState(),
  action: All,
): StaticDataState {
  const alertsKey = 's_alerts';
  switch (action.type) {
    case INIT as string:
    case UPDATE as string:
      try {
        const data = JSON.parse(localStorage.getItem(alertsKey)) || {};
        return {
          ...state,
          ...data,
        };
      } catch (e) {
        localStorage.removeItem(alertsKey);
      }
      break;
    case AuthActionTypes.LOGOUT_SUCCESS as string:
      localStorage.removeItem(alertsKey);
      break;
    case StaticDataActionTypes.UPDATE: {
      localStorage.setItem(alertsKey, JSON.stringify(action.payload));
      return {
        ...state,
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
